import style from "./Login.module.css";
import { useTranslation } from "react-i18next";
import { LoginForm } from "@/features/auth/components/loginForm/LoginForm";

import { Link, Navigate } from "react-router-dom";

import promoVideo from "@/assets/preview.mp4";

import FundedEU from "@/assets/images/funded-EU.jpg";

import Logo from "@/ui/logo/Logo";
import Icon from "@/ui/icon/Icon";
import LanguageSwitcher from "@/ui/languageSwitcher/LanguageSwitcher";
import { FUNDING_ALT } from "@/ui/euFunding/EuFunding";

import { useUser } from "@/features/auth/hooks/useUser";

function Login() {
	const { t } = useTranslation();
	const { isLoggedIn } = useUser();

	if (isLoggedIn) return <Navigate to="/" />;

	return (
		<div className={style.grid}>
			<div className={style.left}>
				<div className={style.header}>
					<Logo />
					<div className={style.headerActions}>
						<LanguageSwitcher />
						<Link to="/register" className={style.createAccount}>
							<span>{t("common:nav.register")}</span>
							<Icon icon="fa-user" />
						</Link>
					</div>
				</div>
				<div className={style.loginFormHolder}>
					<LoginForm />
				</div>

				<div className={style.footer}>
					<p className={style.rights}>
						{t("auth:login.rights", {
							year: new Date().getFullYear(),
						})}
					</p>
					<img src={FundedEU} alt={FUNDING_ALT} />
				</div>
			</div>

			<div className={style.other}>
				<PromoVideoPreview />
				<div className={style.foundedBy}>
					<img src={FundedEU} alt={FUNDING_ALT} />
				</div>
			</div>
		</div>
	);
}

function PromoVideoPreview() {
	return (
		<div className={style.promo}>
			<video
				className={style.video}
				autoPlay
				muted
				loop
				playsInline
				src={promoVideo}
			/>
		</div>
	);
}

export default Login;
